import { useMutation } from 'react-query';
import { addCommentDemand } from 'src/services/api/demands';

function useAddCommentDemand() {
  return useMutation(({ demand, params }) => {
    console.log("ENTRA A ENVIAR useAddCommentDemand con", demand, "y params", params);
    addCommentDemand(demand, params);
  });
}


export default useAddCommentDemand;
